import { TypDokladuE } from '@generated/be';

export const dokladTotoznostiOptions = [
  {
    id: TypDokladuE.Id,
    label: 'Občanský průkaz',
  },
  {
    id: TypDokladuE.P,
    label: 'Cestovní pas',
  },
  {
    id: TypDokladuE.Ir,
    label: 'Povolení k pobytu',
  },
  {
    id: TypDokladuE.Vs,
    label: 'Vízový štítek',
  },
  {
    id: TypDokladuE.Ps,
    label: 'Pobytový štítek',
  },
  {
    id: TypDokladuE.Op,
    label: 'Občanský průkaz bez strojově čitelných údajů',
  },
];
